import React, { useState } from 'react'
import style from "./style/Footer.module.css"
import { LinkedIn } from '@mui/icons-material'
import TelegramIcon from '@mui/icons-material/Telegram';
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from '@mui/icons-material/GitHub';

function Footer() {

    const [title, setTitle] = useState("My social networks")
    const [headingColor, setHeadingColor] = useState('white')

    const mouseOver = (e) => {
        let targetItem = e.target
        let targetTag = targetItem.tagName
        let targetNetwork = targetItem.getAttribute("network")

        if (targetTag === "svg") {
            if (targetNetwork === "LinkedIn") {
                setTitle("LinkedIn")
                setHeadingColor("#007ab9")
                return;
            }

            if(targetNetwork === "Telegram"){
                setTitle("Telegram")
                setHeadingColor("#27a3e2")
            return 
            }
            if(targetNetwork === "Instagram"){
                setTitle("Instagram")
                setHeadingColor("#f23a77")
            return;
            }
            if(targetNetwork === "GitHub"){
                setTitle("GitHub")
                setHeadingColor("#551a8b")
            return;
            }
            }
            if(targetTag === "UL"){
                setTitle("My social networks")
                setHeadingColor("#fff")
            return;
            }
        }
    

    return (
        <footer className={style.footer} >
            <div className={style.footer__container}>
                <h2 style={{color: headingColor}} className={style.footer__h2}>{title}</h2>
                <nav className={style.footer__nav}>
                    <ul id="contactMe" className={style.footer__ul} onMouseOver={mouseOver}>
                        <li><a target='_blank' href="https://www.linkedin.com/in/pavel-glushkov-1a8007245/">
                            <LinkedIn network="LinkedIn" sx={{
                            padding: "7px",
                            fontSize: "65px",
                            color:"#fff",
                            backgroundColor: "#007ab9",
                            borderRadius: "50%"
                            
                        }}/>
                            </a></li>
                        <li  >
                            <a target='_blank' href="https://t.me/P_Hlushkov">                                
                                <TelegramIcon network="Telegram" sx={{
                                    color: "white",
                                    fontSize: "65px",
                                    backgroundColor: "#27a3e2",
                                    padding: "7px",
                                    borderRadius: "50%",
    
                                }}/>
                            </a>
                        </li>
                        <li>
                            <a target='_blank' href="https://instagram.com/pasha_0002?igshid=MzMyNGUyNmU2YQ==">
                                <InstagramIcon network="Instagram" sx={{
                                    color: "white",
                                    fontSize: "65px",
                                    backgroundColor: "#f23a77",
                                    padding: "7px",
                                    borderRadius: "50%",
    
                                }}/>
                            </a>
                        </li>
                        <li >
                            <a target='_blank' href="https://github.com/PHlushkov">
                                <GitHubIcon network="GitHub" sx={{
                                    fontSize: "65px",
                                }}/>
                            </a>
                        </li>
                    </ul>
                </nav>
                <span className={style.span_border}></span>
                <span className={style.span} >© PHlushkov 2023</span>
            </div>
        </footer>
    )
}

export default Footer